import React from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import InfoTip from './InfoTip';

export default function StatCard({ value, label, subtitle, tooltip }) {
    return (
        <Card variant="outlined" sx={{ textAlign: 'center', p: 2 }}>
            <Typography variant="h4" sx={{ fontWeight: 600 }}>
                {value ?? '-'}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                <Typography variant="body2" color="text.secondary">
                    {label}
                </Typography>
                {tooltip && <InfoTip text={tooltip} />}
            </Box>
            {subtitle &&
                <Typography variant="caption" color="text.disabled">
                    {subtitle}
                </Typography>
            }
        </Card>
    );
}
